export const LandingPageText = {
  "_1": "luchtkwaliteitsinformatie, ",
  "_2": "gedetailleerd, real-time en makkelijk te gebruiken",
  "_3": "Uitgebreide luchtkwaliteitsinformatie voor elke locatie",
  "_4": "real-time",
  "_5": "gemakkelijk te gebruiken en interpreteren",
  "_6": "vlotte integratie",
  "_7": "Welke domeinen?",
  "_8": "Luchtkwaliteit is een hot topic.",
  "_9": "Integreer aircheckr in uw producten/diensten en verbeter de gezondheid & gebruikservaring van uw klanten",
  "_10": "Probeer aircheckr nu zelf"
};

export const InteractiveMapText = {
  "car": {
    "title": "Slimme autos",
    "body": "Ik rijd in een elektrische auto, maar ik adem nog steeds de uitlaat van alle andere auto's in"
  },
  "bike": {
    "title": "Gezondste route",
    "body": "Ik breng mijn dochter iedere dag met de fiets naar school. Dat is gezond, toch?"
  },
  "person": {
    "title": "Outdoor",
    "body": "We ademen tot 8 keer meer (slechte) lucht tijdens het sporten. Wat is dan het beste moment om buiten actief te zijn?"
  },
  "home": {
    "title": "Thuis",
    "body": "Ik wil dit huis kopen, maar welke lucht zullen mijn kinderen inademen als ze in de tuin spelen?"
  },
  "office": {
    "title": "Kantoor",
    "body": "Houdt het ventilatiesysteem ook rekening met de kwaliteit van de buitenlucht?"
  },
  "industry": {
    "title": "Intelligence",
    "body": "Hoe verandert de luchtkwaliteit in tijd en ruimte?"
  }
}

export const VacancyText = {
  text: "<span>We zoeken momenteel een enthousiaste <strong>Project Manager/Business Developer aircheckr</strong>.</span><span>Ben jij de persoon die we zoeken?</span>",
  link: "http://nazka.be/jobs/Vacature_BusDev_NL.pdf",
  cta: "bekijk vacature"
}

export const IndustrySmallText = {
  "auto": {
    "title": "Automobiel",
    "body": "Maak auto's slim en gezond door de airconditioning te automatiseren en uw klanten informatie over luchtkwaliteit aan te bieden."
  },
  "ho": {
    "title": "Huis & Kantoor",
    "body": "Til ventilatie-, luchtzuiverings-systemen of vastgoedwebsites naar een hoger niveau door middel van hoogkwalitatieve luchtkwaliteits-informatie tot op straatniveau."
  },
  "outdoor": {
    "title": "Outdoor",
    "body": "Geef uw klanten informatie over luchtkwaliteit om hun activiteiten te plannen of bij te houden."
  },
  "info": {
    "title": "Informatief",
    "body": "Geef 'digital signage' of informatieve websites een boost met regelmatig veranderende luchtkwaliteits-informatie (real-time en voorspelling)."
  },
  "health": {
    "title": "Digitale gezondheid",
    "body": "Integreer de aircheckr info, waarschuwingen en aanbevelingen om gevoelige groepen adequaat te informeren."
  },
  "intelli": {
    "title": "Intelligence",
    "body": "Gebruik de krachtige aircheckr databank om de gegevens te bestuderen die u nodig hebt."
  }
};

export const Quotes = [
  //==========================
  {
    key: 0,
    "text": "Real-time luchtkwaliteitsgegevens van aircheckr zijn interessant voor heel wat Smart City toepassingen en bedrijven, met een positief effect op het leven en werk van burgers.",
    "author": "Davor Meersman, IMEC en Open & Agile Smart Cities",
  },
  {
    key: 1,
    text: 'Aircheckr maakt slim gebruik van data science om betrouwbare, nauwkeurige, gedetailleerde en real-time voorspellingen van luchtverontreiniging te maken.',
    author: 'Nele Verbiest, Python Predictions'
  },
  {
    key: 2,
    text: 'Kopers willen zoveel mogelijk informatie over de woning waar ze potentieel zullen wonen. Uit onderzoek bij onze gebruikers is gebleken dat luchtkwaliteit een parameter is die ze graag raadplegen.',
    author: 'Wendy Geeraert, CEO Co-Libry'
  }];

export const ApiShowcaseText = {
  title: 'Probeer de Aircheckr City Level API',
  subtitle: 'Verken luchtkwaliteitsgegevens door een land, een administratief level en een regio te selecteren.',
  selectCountry: 'Selecteer Land',
  selectAdminLevel: 'Selecteer administratief level',
  adminLevels: {
    LAU2: 'LAU2 – Steden of gemeenten',
    NUTS3: 'NUTS3 – Districten',
    NUTS2: 'NUTS2 – Provincies'
  },
  selectCity: 'Selecteer een regio',
  searchCountries: 'Zoek landen...',
  searchCities: 'Zoek regio\'s/steden…',
  noCountriesFound: 'Geen landen gevonden',
  noCitiesFound: 'Geen steden gevonden',
  apiResponse: 'API Response',
  loadingApiData: 'API-gegevens laden...',
  errorCountries: 'Kan landen niet laden. Probeer het later opnieuw.',
  errorCities: 'Kan steden niet laden. Probeer het later opnieuw.',
  errorApiData: 'Kan API-gegevens niet laden. Probeer het later opnieuw.',
  footerNote: 'Deze demo is gebaseerd op het <a href="/api_docs/#/?id=city-level-api" target="_blank" rel="noopener noreferrer">City Level API-endpoint</a>, en is slechts een startpunt. <br>De Aircheckr API biedt veel meer functionaliteiten en mogelijkheden - bekijk de <a href="/api_docs" target="_blank" rel="noopener noreferrer">volledige API-documentatie</a> voor meer informatie.'
};

export default LandingPageText;



// WEBPACK FOOTER //
// ./src/input-text/nl/landing_page.js